import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import IMiscSettings from '@/models/IMiscSettings';

export const MiscSettingsMutations = {
    UADVersion: 'mutateUADVersion',
    ShowAnnouncementsModal: 'mutateShowAnnouncementsModal',
    ShowAnnouncementsBanner: 'mutateShowAnnouncementsBanner',
    AnnouncementsModalOpen: 'mutateAnnouncementsModalOpen',
};

@Module({namespaced: true, name: 'miscSettings'})
export default class MiscSettingsStoreModule extends VuexModule/*<IMiscSettings>*/ {
    private settings: IMiscSettings = {
        uadVersion: 2.6,
        showAnnouncementsModal: false,
        showAnnouncementsBanner: false,
        announcementsModalOpen: false,
    };

    get UADVersion(): number {
        return this.settings.uadVersion;
    }

    get ShowAnnouncementsModal(): boolean {
        return this.settings.showAnnouncementsModal;
    }

    get ShowAnnouncementsBanner(): boolean {
        return this.settings.showAnnouncementsBanner;
    }

    get AnnouncementsModalOpen(): boolean {
        return this.settings.announcementsModalOpen;
    }

    @Action
    UADVersionUpdate(version: number) {
        this.context.commit(MiscSettingsMutations.UADVersion, version);
    }

    @Action
    ShowAnnouncementsModalUpdate(show: boolean) {
        this.context.commit(MiscSettingsMutations.ShowAnnouncementsModal, show);
    }

    @Action
    ShowAnnouncementsBannerUpdate(show: boolean) {
        this.context.commit(MiscSettingsMutations.ShowAnnouncementsBanner, show);
    }

    @Action
    AnnouncementsModalOpenUpdate(open: boolean) {
        this.context.commit(MiscSettingsMutations.AnnouncementsModalOpen, open);
    }

    @Mutation
    [MiscSettingsMutations.UADVersion](value: number): void {
        this.settings.uadVersion = value;
    }

    @Mutation
    [MiscSettingsMutations.ShowAnnouncementsModal](value: boolean): void {
        this.settings.showAnnouncementsModal = value;
    }

    @Mutation
    [MiscSettingsMutations.ShowAnnouncementsBanner](value: boolean): void {
        this.settings.showAnnouncementsBanner = value;
    }

    @Mutation
    [MiscSettingsMutations.AnnouncementsModalOpen](value: boolean): void {
        this.settings.announcementsModalOpen = value;
    }

}
